import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidenavContextType {
  open: boolean;
  toggleSidenav: (value: boolean) => void;
}

const SidenavContext = createContext<SidenavContextType | undefined>(undefined);

export function SidenavProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const toggleSidenav = (value: boolean) => {
    setOpen(value);
  };

  return (
    <SidenavContext.Provider value={{ open, toggleSidenav }}>
      {children}
    </SidenavContext.Provider>
  );
}

export function useSidenav() {
  const context = useContext(SidenavContext);
  if (context === undefined) {
    throw new Error('useSidenav must be used within a SidenavProvider');
  }
  return context;
}
